const DEBUG_MODE = 1;
const SILENT = true;

export {SILENT, DEBUG_MODE};
